import React from 'react';
import { AnimatePresence } from 'framer-motion';
import AppLoader from './AppLoader';
import { useLoaderTransition } from '../../../hooks/useLoaderTransition';

/**
 * Affiche le loader pendant `isLoading`, avec durée minimale et sortie fluide.
 * Le contenu est monté dès que `isLoading` est faux (sous le loader en fondu).
 */
export default function AppLoaderGate({
  isLoading,
  children,
  minDuration = 780,
  loaderProps = {},
}) {
  const loaderVisible = useLoaderTransition(isLoading, { minDuration });

  return (
    <>
      {!isLoading && children}
      <AnimatePresence mode="wait">
        {loaderVisible && <AppLoader key="app-loader-gate" {...loaderProps} />}
      </AnimatePresence>
    </>
  );
}
